module.exports = __webpack_public_path__ + "img/booth.0e3a1877.svg";